import '../auth.scss';
import { Form, Header } from 'semantic-ui-react';
import React from 'react';

interface AuthFormProps {
  header: string;
  width?: string;
  children: React.ReactNode;
}

export default function AuthForm({ header, width, children }: AuthFormProps) {
  return (
    <div className="auth-page">

      <div
        className="auth-page__box card"
        style={width ? { maxWidth: width } : undefined}
      >
        <a className="auth-page__logo-link" href="http://conductor.solar">
          <img src="/logo.svg" alt="Conductor Solar Home" width={76} height={76} />
        </a>
        <Header as="h2" className="auth-page__title">
          {header}
        </Header>
        <Form className="auth-form">
          {children}
        </Form>
      </div>
    </div>
  );
}
